import React from "react";
import { Updater } from "use-immer";

import { IgSelect } from "@intelligems/ig-theme";
import { MenuItem, SelectChangeEvent } from "@mui/material";

interface FilterMethodHeaderDropdownProps {
  filterOptions: string[];
  selectedFilterOption: string;
  setSelectedFilterOption: Updater<string>;
}

export const FilterMethodHeaderDropdown = ({
  filterOptions,
  selectedFilterOption,
  setSelectedFilterOption,
}: FilterMethodHeaderDropdownProps) => {
  const onChange = (event: SelectChangeEvent<string>) => {
    setSelectedFilterOption(event.target.value);
  };
  return (
    <IgSelect
      disableUnderline={true}
      labelId="analytics-filter-graph-select"
      id="analytics-filter-graph-select"
      value={selectedFilterOption}
      variant={"standard"}
      sx={{
        fontSize: "14px",
        "& .MuiSelect-select": {
          padding: 0,
        },
        "& .MuiTypography-root": {
          fontSize: "14px",
          fontWeight: 600,
        },
      }}
      onChange={onChange}
    >
      {filterOptions.map((filter) => (
        <MenuItem
          sx={{ fontSize: "14px" }}
          disableTouchRipple={true}
          dense
          key={filter}
          value={filter}
        >
          {filter}
        </MenuItem>
      ))}
    </IgSelect>
  );
};
